// Mirrored in sonder-homepage-gatsbyjs/src/helpers/bot-detection.ts — keep both patterns in sync.
// `curl\/` and `wget\/` are slash-anchored (unlike the other tokens) because the bare substrings
// "curl"/"wget" are short and common enough to appear inside legitimate browser UAs; requiring the
// trailing "/" restricts the match to the actual HTTP-client UA form.
const BOT_UA_PATTERN =
  /bot|crawl|spider|slurp|facebookexternalhit|bingpreview|googlebot|yandex|baiduspider|duckduckbot|semrush|ahref|mj12bot|dotbot|petalbot|bytespider|gptbot|claudebot|ccbot|applebot|twitterbot|linkedinbot|whatsapp|telegrambot|discordbot|pingdom|uptimerobot|headlesschrome|phantomjs|selenium|datadogsynthetics|googleother|shap-user|google-inspectiontool|chrome-lighthouse|phantomas|python-requests|python-httpx|axios|curl\/|wget\/|go-http-client|okhttp/i;

export function isBotUserAgent(userAgent?: string): boolean {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  if (!ua) {
    return false;
  }
  return BOT_UA_PATTERN.test(ua);
}
